<template>
  <div class="div_prim">

      <el-row :gutter="60">
        <el-col :span="24" class="card-01">

          <el-row :gutter="20">
            <el-col :span="24" class="modal_title middle_blue">Uživatelé
            </el-col>
          </el-row>

          <el-row style="margin-bottom: 30px;">
            <el-col :span="21">
              <div style="width: 300px">
                <el-input placeholder="Zadejte řetězec pro vyhledání" v-model="filter_users" class="input-with-select" size="small" clearable @keyup.enter.native="search_users" @clear="search_users">
                  <el-button slot="append" icon="el-icon-search" size="small" style="background: #74a17c; color: white; border-radius: 0 3px 3px 0;" @click.native="search_users"></el-button>
                </el-input>
              </div>
            </el-col>
            <el-col :span="3">
              <el-button :disabled="!loginuser.admin" class="btn-green" icon="el-icon-user" size="small" @click="user_new"> Nový uživatel</el-button>
            </el-col>
          </el-row>

              <el-table
                ref="users_table"
                :data="users"
                style="width: 100%; word-break: normal;"
                row-key="id_user"
                v-loading="loading_users"
                element-loading-text="Loading..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(211, 227, 218, 0.8)"
                border
                highlight-current-row
                @current-change="CurrentChange_users"
                @sort-change="SortChange_users"
                >
                <el-table-column
                  prop="degrees_1"
                  label="Titul"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="f_name"
                  label="Jméno"
                  width="120">
                </el-table-column>
                <el-table-column
                  prop="l_name"
                  label="Příjmení"
                  width="150"
                  sortable="custom">
                </el-table-column>
                <el-table-column
                  prop="degrees_2"
                  label="Titul"
                  center
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="phone"
                  label="Telefon"
                  width="140">
                </el-table-column>
                <el-table-column
                  prop="email"
                  label="E-mail"
                  width="300"
                  sortable="custom">
                </el-table-column>
                <el-table-column
                  prop="dept_name"
                  label="Oddělení"
                  width="160"
                  sortable="custom">
                </el-table-column>
                <el-table-column
                  prop=""
                  label="Role"
                >
                  <template slot-scope="props">
                    <div v-if="props.row.admin"> ADMIN </div>
                    <div v-else-if="props.row.editor"> EDITOR </div>
                    <div v-else> GUEST </div>
                  </template>
                </el-table-column>
                <el-table-column
                  width="200"
                  label="Akce"
                  fixed="right"
                  align="center">
                  <template slot-scope="props">
                  <el-tooltip content="Jen pro čtení" placement="top" effect="light" :open-delay="500">
                    <el-button class="btn-grey-lit" size="mini" icon="el-icon-view" @click="user_show( props.$index, props.row, $event )"></el-button>
                  </el-tooltip>
                    <el-tooltip content="Edit" placement="top" effect="light" :open-delay="500">
                      <el-button :disabled="!loginuser.admin" class="btn-grey-lit" size="mini" icon="el-icon-edit" @click="user_edit( props.$index, props.row, $event )"></el-button>
                    </el-tooltip>
                    <el-tooltip content="Delete" placement="top" effect="light" :open-delay="500">
                      <el-button :disabled="!loginuser.admin" class="btn-red-lit" size="mini" icon="el-icon-delete" @click="user_delete( props.$index, props.row, $event )">
                      </el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>

          <el-row>
            <el-col>
              <el-pagination
                @size-change="SizeChangePage_pagination_users"
                @current-change="CurrentChangePage_pagination_users"
                :current-page.sync="pagination_users.currentPage"
                :page-sizes="pagination_users.perPageOptions"
                :page-size="pagination_users.perPage"
                style="margin-top: 60px; margin-bottom: 60px;"
                :background="true"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pagination_users.total"
                align="right">
              </el-pagination>
            </el-col>
          </el-row>
        </el-col>
      </el-row>


    <el-dialog :visible.sync="modal_user" width="100%" headerClasses="justify-content-center" :show-close="false" center :close-on-click-modal="false" :close-on-press-escape="false" @closed="closed_modal_user">
      <el-form ref="form_user" :rules="rules_user" size="mini" :model="user">
        <el-row>
          <el-col :span="24">
            <el-card class="card_modal_patient">
              <el-row>
                <el-col :span="5" class="modal_patient_1a" style="text-align: right; padding-right: 30px; padding-left: 30px">
                  <p v-if="loginuser.admin && user.id_user < 1" class="modal_green_small mt-50">NOVÝ</p>
                  <p v-else-if="loginuser.admin && !modal_user_ro && user.id_user > 0" class="modal_green_small mt-50">EDITACE</p>
                  <p v-else class="modal_green_small mt-50">JEN PRO ČTENÍ</p>

                  <p class="modal_title light_blue" style="margin-bottom: 0;">Uživatel</p>
                  <div v-if="loginuser.admin">
                    <p class="modal_green_mini">ADMINISTRÁTOR</p>
                    <p class="modal_white mini">Máte oprávnění PŘIDAT/EDITOVAT/MAZAT uživatele.</p>
                    <p class="modal_white mini">Pokud má uživatel zároveň roli lékaře (vstupuje do seznamu lékařů v modálu Kontroly), zaškrtněte prosím volbu "Lékař".</p>
                    <p class="modal_white mini">Pokud má uživatel zároveň roli editora, zaškrtněte prosím volbu "Editor".</p>
                    <p class="modal_white mini">ADMIN má také právo MAZAT pacienta.</p>
                  </div>
                  <div v-else-if="loginuser.editor">
                    <p class="modal_green_mini">EDITOR</p>
                    <p class="modal_white mini">V modálu Pacient máte oprávnění PŘIDAT/EDITOVAT. Mazání pacienta přísluší ADMINISTRÁTOROVI.</p>
                    <p class="modal_white mini">V modálech DIAGNÓZA/OPERACE/LÉČBA/KONTROLA máte oprávnění PŘIDAT/EDITOVATT/MAZAT.</p>
                    <p class="modal_white mini">V modálu Uživatel máte oprávnění JEN PRO ČTENÍ. Požadujete-li přidání nového uživatele, editaci jeho údajů, případně smazání stávajícího uživatele, kontaktujte prosím ADMINISTRÁTORA.</p>
                    <p class="modal_white mini">V modálu Správa číselníků máte oprávnění PŘIDAT/EDITOVAT/MAZAT.</p>
                  </div>
                  <div v-else>
                    <p class="modal_green_mini">GUEST </p>
                    <p class="modal_white mini">Máte oprávnění JEN PRO ČTENÍ.</p>
                  </div>
                </el-col>
                <el-col :span="19" class="modal_patient_1b" style="padding: 0">
                  <el-row :class="{ modal_1b_ro: modal_user_ro, modal_1b: !modal_user_ro }">
                    <div style="padding: 20px">
                      <el-col :span="14">
                        <h5 class="modal_dark_blue title-1">
                        <span class="fa-stack" style="color: #00134b; padding: 0 10px">
                          <i class="fas fa-circle fa-stack-2x"></i>
                          <i class="fas fa-info fa-stack-1x fa-inverse"></i>
                        </span>
                         Osobní údaje
                        </h5>
                        <el-row class="card-modal white" style="min-height: 200px;">
                          <el-col :span="4">
                            <div class="modal_label dark_grey">Titul</div>
                            <el-form-item prop="">
                              <el-input type="text"
                                        placeholder=""
                                        v-model="user.degrees_1"
                                        size="small"
                                        :readonly="modal_user_ro"
                                        >
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6" :offset="1">
                            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Jméno</div>
                            <el-form-item prop="f_name">
                              <el-input type="text"
                                        placeholder=""
                                        v-model="user.f_name"
                                        size="small"
                                        :readonly="modal_user_ro"
                                        >
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="8" :offset="1">
                            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Příjmení</div>
                            <el-form-item prop="l_name">
                              <el-input type="text"
                                        placeholder=""
                                        v-model="user.l_name"
                                        size="small"
                                        :readonly="modal_user_ro"
                                        >
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="3" :offset="1">
                            <div class="modal_label dark_grey">Titul</div>
                            <el-form-item prop="">
                              <el-input type="text"
                                        placeholder=""
                                        v-model="user.degrees_2"
                                        size="small"
                                        :readonly="modal_user_ro"
                                        >
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="9">
                            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Oddělení</div>
                            <el-form-item prop="id_dept">
                              <el-select
                                v-model="user.id_dept"
                                default-first-option
                                filterable
                                clearable
                                :disabled="modal_user_ro"
                                placeholder="Vyber oddělení">
                                <el-option
                                  v-for="one of l_depts"
                                  :key="one.id_dept"
                                  :label="one.dept_name"
                                  :value="one.id_dept"
                                  size="small"
                                  >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="5">
                            <div class="modal_label dark_grey">Lékař</div>
                            <el-checkbox :disabled="modal_user_ro" v-model="user.is_doctor">ANO</el-checkbox>
                          </el-col>
                          <el-col :span="10">
                            <div class="modal_label dark_grey">Role</div>
                            <el-checkbox :disabled="modal_user_ro" v-model="user.editor">Editor</el-checkbox>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="10">
                        <h5 class="modal_dark_blue title-1">
                        <span class="fa-stack" style="color: #00134b; padding: 0 10px">
                          <i class="fas fa-circle fa-stack-2x"></i>
                          <i class="fas fa-home fa-stack-1x fa-inverse"></i>
                        </span>
                         Kontaktní údaje
                        </h5>
                        <el-row class="card-modal white" style="min-height: 200px;">
                          <el-col :span="14">
                            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> E-mail</div>
                            <el-form-item prop="email">
                              <el-input type="text"
                                        v-model="user.email"
                                        size="small"
                                        :disabled="modal_user_ro"
                                        >
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="9" :offset="1">
                            <div class="modal_label dark_grey"> Telefon</div>
                            <el-input type="text"
                                      v-model="user.phone"
                                      size="small"
                                      :disabled="modal_user_ro"
                                      >
                            </el-input>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col style="min-height: 5px; margin-top: 30px">
                      </el-col>
                      <el-col :span="14">
                        <h5 class="modal_dark_blue title-1">
                        <span class="fa-stack" style="color: #00134b; padding: 0 10px">
                          <i class="fas fa-circle fa-stack-2x"></i>
                          <i class="fas fa-pencil-alt fa-stack-1x fa-inverse"></i>
                        </span>
                         Poznámky
                        </h5>
                        <el-row class="card-modal white">
                          <el-col :span="24">
                            <div class="modal_label dark_grey">Privátní</div>
                            <textarea rows="3"
                                class="form-control border-input"
                                v-model="user.note"
                                :disabled="modal_user_ro"
                                >
                            </textarea>
                          </el-col>
                        </el-row>
                      </el-col>
                    </div>
                  </el-row>
                  <el-row :gutter="20" style="padding: 5px 20px 20px 30px;">
                    <el-col :span="24">
                      <div><span class="modal_label dark_green">*</span> <i>povinné údaje</i></div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </el-form>

      <template slot="footer">
        <el-button v-if="!modal_user_ro && user.id_user === 0" class="btn-green-big" link @click.native="user_new_save('form_user')"><i class="el-icon-finished"></i> ULOŽIT </el-button>
        <el-button v-if="!modal_user_ro && user.id_user > 0" type="info" link @click.native="user_edit_save('form_user')"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
        <el-button class="btn-blue" link @click.native="modal_user_close"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import Examinations from 'src/components/Views/Examinations.vue';

  const nthOptions = ['Cefalea', 'Porucha vědomí'];

  export default {
    components: {
      Examinations,

    },

    data () {
      return {
        props: {
          multiple: true,
        },

        checkList: ['selected and disabled','Asympt'],
        textarea: '',


        rules_user: {
          id_dept: [
            { required: true, message: 'Tato položka je vyžadována.', trigger: 'blur' },
          ],
          email: [
            { type: "email", message: 'E-mail není ve správném tvaru.', trigger: 'blur' },
            { required: true, message: 'Tato položka je vyžadována.', trigger: 'blur' },
          ],
          f_name: [
            { required: true, message: 'Tato položka je vyžadována.', trigger: 'blur' },
          ],

          l_name: [
            { required: true, message: 'Tato položka je vyžadována.', trigger: 'blur' },
          ],

        },

      }
    },


    computed: {
      ...mapState({
        token: state => state.token,
        loginuser: state => state.loginuser,
        user: state => state.user,
        users: state => state.users,
        l_depts: state => state.l_depts,

        modal_user: state => state.modal_user,
        modal_user_ro: state => state.modal_user_ro,
        sorting_users: state => state.sorting_users,
        pagination_users: state => state.pagination_users,
        loading_users: state => state.loading_users,

        prvni_priznak_pos: state => state.prvni_priznak_pos,


      }),

      ...mapGetters({

      }),


      filter_select_column: {
        get () { return this.$store.state.filter_select_column; },
        set (value) { this.$store.commit('m_filter_select_column', value); }
      },

      filter_users: {
        get() { return this.$store.state.filter_users; },
        set(value) { this.$store.commit('m_filter_users', value); }
      },


    },

    methods: {
      ...mapMutations({
        m_modal_user: 'm_modal_user',
        m_modal_user_ro: 'm_modal_user_ro',
        m_user_item: 'm_user_item',
        m_user_reset: 'm_user_reset',
        m_user_id: 'm_user_id',
        m_user: 'm_user',
        m_filter_users: 'm_filter_users',


      }),


      ...mapActions({
        a_user: 'a_user',
        a_user_new: 'a_user_new',
        a_user_update: 'a_user_update',
        a_user_delete: 'a_user_delete',
        a_users: 'a_users',

      }),


      onSubmit() {
        console.log('submit!');
      },


      user_new() {
        this.m_modal_user_ro(false);
        this.m_user_reset();
        this.m_modal_user(true);
      },


      user_show (index, row, event) {
        event.stopImmediatePropagation();
        this.m_modal_user_ro(true);
        this.m_user_reset();
        this.user.id_user = row.id_user;
        this.a_user( {'get_id_user': row.id_user} );
        this.m_modal_user(true);
      },


      user_new_save() {
        this.$refs["form_user"].validate((valid) => {
          if (valid) {
            this.a_user_new( this.user );
            this.m_modal_user(false);
          } else {
            this.$alert(valid_text, 'Title', {
              confirmButtonText: 'OK',
              dangerouslyUseHTMLString: true
              });
            return false;
          }
        });
      },


      user_edit (index, row, event) {
        this.m_modal_user_ro(false);
        event.stopImmediatePropagation();
        this.m_user_reset();
        this.user.id_user = row.id_user;
        this.a_user( {'get_id_user': row.id_user} );
        this.m_modal_user(true);
      },


      user_edit_save() {
        this.$refs["form_user"].validate((valid) => {
          if (valid) {
            this.a_user_update( { "myuser": this.user } );
            this.m_modal_user(false);
          } else {
            this.$alert(valid_text, 'Title', {
              confirmButtonText: 'OK',
              dangerouslyUseHTMLString: true
              });
            return false;
          }
        });
      },


      user_delete (index, row, event) {
        event.stopImmediatePropagation();

        this.$confirm(`Opravdu chcete smazat uživatele <b>${row.f_name} ${row.l_name}</b>?`, 'Warning', {
          confirmButtonText: 'ANO',
          cancelButtonText: 'NE',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(() => {
          this.a_user_delete({ 'delete_id_user': row.id_user });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Smazání uživatele přerušeno.'
          });
        });
      },


      search_users() {
        this.a_users();
      },


      modal_user_close() {
        this.m_modal_user(false);
        this.$refs["form_user"].resetFields();
      },


      closed_modal_user() {
        this.m_modal_user_ro(false);
      },


      CurrentChange_users(val) {
        console.log(val.id_user);
        if (val.id_user > 0) {
          this.m_user_id(val.id_user);
        } else {
          this.m_user_id(0);
        }

      },


      SortChange_users(val) {
        this.sorting_users.sorting_prop = val.prop;
        this.sorting_users.sorting_ordering = val.order;
        this.pagination_users.currentPage = 1;
        this.a_users();
      },


      CurrentChangePage_pagination_users(val) {
        this.pagination_users.currentPage = val;
        this.a_users();
      },


      SizeChangePage_pagination_users(val) {
        this.pagination_users.perPage = val;
        this.pagination_users.currentPage = 1;
        this.a_users();
      },

    },


    beforeCreate () {
    },

    created () {
    },

    beforeMount () {
    },

    mounted () {
      this.a_users();

    },

    beforeUpdate () {
    },

    updated () {

    },

    afterDestroy () {
    },

    destroyed () {
    },




  }
</script>

<style lang="scss" scoped>

.el-cascader {
  display: block;
}

.el-select {
  padding: 0 !important;
}

.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
 }
}

.card_modal_patient {
  background: #00134b !important;
  border: 0px solid #e1ecf2 !important;
  margin: 20px !important;
  border-radius: 20px !important;
  box-shadow: 5px 5px 5px #cdd1dd !important;
}

.modal_patient_1a {
  background: #00134b !important;
  padding-right: 50px !important;
}

.modal_patient_1b {
  background-color: #e1ecf2 !important;
}

.el-loading-spinner i {
  font-size: 70px !important;
}

.el-loading-spinner {
  top: 25% !important;
}

</style>
